(function () {
	'use strict';

	const modules = [];

	angular.module('HdModule', modules);
})();
